export default __webpack_public_path__ + "static/usta-favicon_alt-20f5739df2b6a74304b26d3c2497971a.png";